import { useTranslation } from 'react-i18next';
import SelectionBasic from '../../../components/common/SelectionBasic/SelectionBasic';
import { Divider } from 'antd';
import { Checkbox } from 'antd';
import SearchComponent from '../../../components/common/SearchComponent/SearchComponent';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { reloadSaleProducts } from '../../../store/reducers/sale-product.reducer';
import { useParams } from 'react-router-dom';
import ButtonPrimaryLarge from '../../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import { Icon } from '../../../components/icon/icon';
import { cn } from '../../../utils/string/cn.utils';
import ButtonIconOutlineMedium from '../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import i18n from '../../../languages/i18n';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const sizeItems = [
  { key: '1200', label: '1200 mm' },
  { key: '1400', label: '1400 mm' },
  { key: '1600', label: '1600 mm' },
  { key: '1800', label: '1800 mm' },
  { key: '2000', label: '2000 mm' },
];
const priceItems = [
  { key: '1', label: `${i18n.t('Under')} ${convertForeignCurrency(1000000)}` },
  {
    key: '2',
    label: `${convertForeignCurrency(1000000)} - ${convertForeignCurrency(5000000)}`,
  },
  {
    key: '3',
    label: `${convertForeignCurrency(5000000)} - ${convertForeignCurrency(10000000)}`,
  },
  {
    key: '4',
    label: `${convertForeignCurrency(10000000)} - ${convertForeignCurrency(30000000)}`,
  },
  {
    key: '5',
    label: `${convertForeignCurrency(30000000)} - ${convertForeignCurrency(50000000)}`,
  },
  {
    key: '6',
    label: `${i18n.t('Up')}  ${convertForeignCurrency(50000000)}`,
  },
];
const appItems = [
  { key: 'design', label: i18n.t('App Customizable') },
  { key: 'normal', label: i18n.t('Not Customizable via the App') },
];
const discountItems = [
  { key: '1', label: i18n.t('On Promotion') },
  { key: '0', label: i18n.t('No Promotion') },
];

const SectionFilter = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [openFilter, setOpenFilter] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const sizesParam = searchParams.get('size');
  const pricesParam = searchParams.get('price_range');
  const discountsParam = searchParams.get('discount');
  const modesParam = searchParams.get('sale_type');
  const kwParam = searchParams.get('kw') || '';
  const sortByParam = searchParams.get('sort');
  const offsetParam = searchParams.get('offset');

  const updateSearchParams = (key, value) => {
    // Sử dụng searchParams.entries() để lấy các cặp key-value
    const params = Object.fromEntries(searchParams);
    if (key !== 'offset') {
      if (key === 'kw') {
        if (value) {
          params[key] = value;
        } else {
          delete params[key];
        }
      } else {
        const temp = params[key] ? params[key].split(',') : [];
        if (temp.includes(value)) {
          // Nếu giá trị đã tồn tại, loại bỏ nó
          const newValue = temp
            .filter(item => item !== value && item !== '')
            .join(',');
          if (newValue) {
            params[key] = newValue;
          } else {
            delete params[key];
          }
        } else {
          // Nếu giá trị chưa tồn tại, thêm nó vào danh sách
          params[key] = [...temp, value].filter(item => item !== '').join(',');
        }
      }

      delete params['offset']; // Reset offset về 0 khi có thay đổi
      setSearchParams(params);
    } else {
      params[key] = value;
      setSearchParams(params);
    }
  };

  return (
    <>
      <section
        className={cn(
          'flex lg:min-w-[300px] z-[1000] w-full lg:relative lg:z-[25] absolute flex-col items-start lg:rounded-[16px] lg:justify-start justify-end lg:h-fit h-full bg-black/25 left-0 right-0 bottom-0 lg:!opacity-100 lg:!pointer-events-auto transition-transform duration-300 ease-in-out',
          openFilter ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
        onClick={() => setOpenFilter(false)}
      >
        <div
          onClick={e => e.stopPropagation()}
          className={cn(
            'flex flex-col lg:items-start lg:justify-start items-end justify-end lg:!translate-y-0 transition-transform duration-300 ease-in-out w-full h-full bg-fills-white lg:bg-transparent',
            openFilter ? 'translate-y-0' : 'translate-y-full'
          )}
        >
          <div className="lg:hidden flex justify-between items-center self-stretch p-[16px] bg-white rounded-t-[16px] border-b-[1px] border-solid border-outline-default-secondary">
            <span className="text-title-large !font-bold">
              {t('Product Filter')}
            </span>
            <ButtonIconOutlineMedium
              icon={<Icon.ICClose />}
              onClick={() => setOpenFilter(false)}
            />
          </div>
          <div className="flex flex-col items-start gap-[16px] bg-white lg:p-[24px] lg:rounded-[16px] p-[16px] self-stretch overflow-y-auto">
            <SearchComponent
              placeholder={t('Search')}
              className={'self-stretch'}
              value={kwParam}
              setValue={value => updateSearchParams('kw', value)}
            />
            <Divider type="horizontal" className="!p-0 m-0" />
            <div className="flex flex-col items-start gap-[16px] self-stretch">
              <span className="text-body-large font-semibold">{t('Size')}</span>
              <div className="grid grid-cols-3 items-start justify-start gap-[8px] self-stretch">
                {sizeItems.map(item => (
                  <SelectionBasic
                    key={item.key}
                    label={item.label}
                    actived={sizesParam?.split(',')?.includes(item.key)}
                    onClick={() => {
                      updateSearchParams('size', item.key);
                    }}
                    className="text-black-medium"
                  />
                ))}
              </div>
            </div>
            <Divider type="horizontal" className="!p-0 m-0" />
            <div className="flex flex-col items-start gap-[16px] self-stretch">
              <span className="text-body-large font-semibold">
                {t('Price')}
              </span>
              <div className="flex flex-col items-start justify-start gap-[8px] self-stretch">
                {priceItems.map(item => (
                  <Checkbox
                    key={item.key}
                    value={item.key}
                    checked={pricesParam?.split(',').includes(item.key)}
                    className="flex items-center gap-[8px] text-black-medium"
                    onChange={e => {
                      updateSearchParams('price_range', item.key);
                    }}
                  >
                    <span className="text-body-medium">{item.label}</span>
                  </Checkbox>
                ))}
              </div>
            </div>
            <Divider type="horizontal" className="!p-0 m-0" />
            <div className="flex flex-col items-start gap-[16px] self-stretch">
              <span className="text-body-large font-semibold">
                {t('Promotion')}
              </span>
              <div className="flex items-start justify-start gap-[8px] self-stretch">
                {discountItems.map(item => (
                  <SelectionBasic
                    key={item.key}
                    label={item.label}
                    actived={discountsParam?.split(',')?.includes(item.key)}
                    onClick={() => {
                      updateSearchParams('discount', item.key);
                    }}
                    className="text-black-medium w-fit"
                  />
                ))}
              </div>
            </div>
            <div className="flex flex-col items-start gap-[16px] self-stretch">
              <span className="text-body-large font-semibold">
                {t('Tùy chỉnh qua App')}
              </span>
              <div className="flex flex-col items-start justify-start gap-[8px] self-stretch">
                {appItems.map(item => (
                  <Checkbox
                    key={item.key}
                    className="flex items-center gap-[8px] text-black-medium"
                    checked={modesParam?.split(',').includes(item.key)}
                    value={item.key}
                    onChange={e => {
                      updateSearchParams('sale_type', item.key);
                    }}
                  >
                    <span className="text-body-medium">{item.label}</span>
                  </Checkbox>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="lg:hidden flex absolute z-[20] left-0 right-0 bottom-0 p-[16px] pb-[32px] flex-col justify-center items-center gap-[16px] self-stretch bg-white shadow-dropShadow16">
        <ButtonPrimaryLarge
          title={t('Product Filter')}
          onClick={() => {
            setOpenFilter(true);
          }}
          posIcon={<Icon.ICFilter />}
          className={'w-full'}
        />
      </section>
    </>
  );
};

export default SectionFilter;
